export default "__VITE_ASSET__DNdYzabd__"